import React, {Component} from 'react';
import { Table } from 'react-bootstrap';
import moment from 'moment';
import swal from 'sweetalert';
import Notifications from 'react-notify-toast';

class TableCreateAliquots extends Component{
	constructor(props){
		super(props);

		this.generate = this.generate.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.generateOne = this.generateOne.bind(this);
		this.getDataTable = this.getDataTable.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.onCheck = this.onCheck.bind(this);
		this.checkAll = this.checkAll.bind(this);
		this.equivalentChange = this.equivalentChange.bind(this);

		this.state = {
			component:[],
			all:true,
			num_alicuots:"",
			target:[],
			checked_all: true,
			equivalents:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleChange(e){
		if(this.props.state.option === 'Unit'){
			if(e.target.name === 'num_alicuots'){
				/*if(e.target.value < 2){
					this.setState({num_alicuots:'2'});
				}else{*/
					this.setState({
						[e.target.name] : e.target.value
					})
				//}
			}
		}else{
			this.setState({
				[e.target.name] : e.target.value
			})
		}
	}

	generate(){
		var indices = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S",
						"T","U","V","W","X","Y","Z"];

		var prefijo = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s',
						't','u','v','w','x','y','z'];

		var units = "";
		if(this.props.state.aliquots.units !== undefined){
			units = this.props.state.aliquots.units;
		}else{
			units = this.props.state.aliquots;
		}

		if(parseInt(this.state.num_alicuots) <= 10){
			units.map((a, i)=>{
				var input  = [];
				var parts = 0;

				if(this.state.num_alicuots.indexOf('.') !== -1){
					parts = Math.ceil(parseFloat(this.state.num_alicuots,10));
				}else{
					parts = parseInt(this.state.num_alicuots,10);
				}

				
				var equivalents = [];
				for(var x = 0; x < parts; x++){
					
					if(this.state.component[i].component_number[0] === "0"){ // A0, B0, C0,... 
						var fractioning = indices[x + (this.state.component[i].fraction)]+this.state.component[i].component_number[0];
					}else{
						
						if(x === 0){
							var fractioning = this.state.component[i].component_number[0]+"0";
						}else{
							var fractioning = this.state.component[i].component_number[0]+prefijo[(x - 1) + this.state.component[i].fraction] //(parseInt(c.component_number[1])+1);
						}
					}

					input.push({
						id:"input_"+a.unit.id+"_"+x,
						value: "",//val
						fraction_number:fractioning
					});

					equivalents.push({id:x+1, value:""});

				}
				this.state.component[i].value = this.state.num_alicuots;
				this.state.component[i].input = input;

				this.setState({equivalents:equivalents});
			})
			this.forceUpdate();
		}else{
			swal('Error', 'El número maximo de alicuotas es de 10', 'error');
		}


		
	}

	generateOne(e){
		var indices = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S",
						"T","U","V","W","X","Y","Z"];

		var prefijo = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s',
						't','u','v','w','x','y','z'];

		var units = this.props.state.aliquots.units !== undefined ? this.props.state.aliquots.units : this.props.state.aliquots;

		if(parseInt(e.target.value) <= 10){
			var equivalents = [];
			this.state.component.map((c, i)=>{
				var input = [];
				var parts = 0;
				if("input_"+c.id === e.target.id){

					units.map((u)=>{
						if(u.unit.id === c.id){
							u.unit.volume = c.volume;
						}
					})

					if(e.target.value.indexOf('.') !== -1){
						parts = Math.ceil(parseFloat(e.target.value));
					}else{
						parts = parseInt(e.target.value,10);
					}

					for(var x = 0; x < parts ; x++){
						var fractioning = "";
						if(c.component_number[0] === "0"){ // A0, B0, C0,... 
							fractioning = indices[(x) + (c.fraction)]+c.component_number[0];
						}else{
							
							if(x === 0){
								fractioning = c.component_number[0]+"0";
							}else{
								fractioning = c.component_number[0]+prefijo[(x-1) + c.fraction] //(parseInt(c.component_number[1])+1);
							}
						}

						input.push({
							id:"input_"+c.id+"_"+x,
							value: "",
							fraction_number:fractioning
						});	

						equivalents.push({id:x+1, value:""});				
					}

					c.value = e.target.value
					c.input = input;
				}
			})

			this.setState({equivalents:equivalents});

			this.forceUpdate();
		}else{
			swal('Error', 'El número maximo de alicuotas es de 10', 'error');
			
		}

		
	}

	getDataTable(){
		var input = [];
		var error_alicuota = 0;
		var error_first = 0;

		var validacion = [];
		var mensaje = "";
		var complete = [];

		var indices = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S",
						"T","U","V","W","X","Y","Z"];

		var prefijo = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s',
						't','u','v','w','x','y','z']

		
		var locked = '';


		this.state.component.map((c, i)=>{

			if(c.check){
				if(c.status === 'BLOQUEADA'){
					locked += c.unit_number;
				}
				var suma = 0;

				for(var x = 0; x < parseInt(c.value,10); x++){
					if(x === 0){
						if(c.component_number[0] === "0"){ // A0, B0, C0,... 
							var fractioning = indices[x + (c.fraction)]+c.component_number[0];
						}else{
							var fractioning = c.component_number[0]+"0";
						}


						input.push({
							number_target: parseInt(c.value),
							unit_id: c.id,
							fraction_number: fractioning, //A0
							volume: parseInt(c.value,10) > 1 ? c.input[x].value : c.volume,
							equivalent_units: this.state.equivalents[x].value
						});

						if(parseInt(c.value,10) > 1){
							if(c.input[x].value <= 0){
								error_first++;
							}
						}
							
					}else{
						var element = document.getElementById("input_"+c.id+"_"+(x));
						
						var value  = element.value;

						if(value === ""){
							error_alicuota++;
						}else{
							if(c.component_number[0] === "0"){ // A0, B0, C0,... 
								var fractioning = indices[x + (c.fraction)]+c.component_number[0];
							}else if(x > 0){
								var fractioning = c.component_number[0]+prefijo[(x - 1) + c.fraction] //(parseInt(c.component_number[1])+1);
								
							}

							input.push({
								number_target: parseInt(c.value,10),
								unit_id: c.id,
								fraction_number: fractioning, //A0
								volume: value.length === "" ? 0 : parseInt(value,10),
								equivalent_units: this.state.equivalents[x] !== undefined ? this.state.equivalents[x].value : ""
							});

							if(parseInt(value,10) < 1){
								error_alicuota++;
							}
						}
					}
				}

				complete.push({"unit_id":c.id, volume:0});
			}
		});

		if(error_alicuota !== 0){
			swal("Error", "Debe ingresar un volumen mayor a cero en todos los componentes", 'error');

		}else if(input.length === 0){
			return "error";

		}else if(error_first > 0){
			swal("Error", "El volumen de la bolsa original no debe ser igual o menor a cero.", 'error');

		}else if(locked !== ''){
			swal('Error', 'No es posible realizar el proceso a las unidades '+locked+' ya que se encuentran bloqueadas', 'error');
			return 'bloqueo';
		}else{
			if(validacion.length > 0 && mensaje === ""){
				this.error_modal.handleShow(validacion);

			}else if(mensaje !== ""){
				swal({
                  	title: "Error",
                  	html:true,
                  	text: mensaje,
                  	type: 'error',
                  	customClass: 'swal-medium',
              	});

			}else{
				return {input: input, complete:complete, incident:[]};	
			}
		}
	}

	onInputChange(e){
		var units = this.props.state.aliquots.units !== undefined ? this.props.state.aliquots.units : this.props.state.aliquots;

		this.state.component.map((c)=>{
			if(c.input !== ""){
				//suma de inputs
				var suma = 0;
				var volume = "0";
				var input_id = "";

				c.input.map((input, i)=>{
					
					if(i > 0){
						if(e.target.id === input.id){
							suma += e.target.value === "" ? 0 : parseInt(e.target.value);
							
							input.value = e.target.value;
						}else{
							suma += input.value === "" ? 0 : parseInt(input.value);
						}

						input_id = parseInt(input.id.split('_')[1],10);
						
						/*units.map((u)=>{
							if(u.unit.id === id_input){
								if(e.target.value === ""){
									volume = parseInt(c.volume,10) - suma;
								}else{
									volume = parseInt(c.volume,10) - (parseInt(e.target.value,10) + suma);
								}

								u.unit.volume = volume;
							}
						})*/
						
						
					}

				})

				c.input[0].value = c.volume - suma;

				units.map((u)=>{
					if(u.unit.id === input_id){
						u.unit.volume = c.input[0].value;
					}
				})
				
			}
		})

		this.forceUpdate();
	}

	onCheck(i){
		this.state.component[i].check = this.state.component[i].check ? false : true;
		this.forceUpdate();
	}

	checkAll(e){
		this.state.checked_all = e.target.checked ? true : false;
		this.state.component.map((c)=>{
			c.check = e.target.checked ? true : false
		});

		this.forceUpdate();
	}

	equivalentChange(e){
		this.state.equivalents.map((eq)=>{
			if(parseInt(e.target.id) === parseInt(eq.id)){
				eq.value = e.target.value;
			}
		});

		this.forceUpdate();
	}

	render(){
		var units = this.props.state.aliquots.units !== undefined ? this.props.state.aliquots.units : this.props.state.aliquots;
		return (
			<div className="col-xs-12">
				<div className="col-xs-12 col-sm-offset-8 col-sm-4" style={{paddingBottom:"1em"}}>
					<div className="col-xs-12 col-sm-8" style={{textAlign:"right"}}>
						<span>Número de alicuotas</span>
					</div>
					<div className="col-xs-12 col-sm-2">
						<input type="number" min="1" max="10" onKeyPress={(e) => this.props.validate(e)} name="num_alicuots" 
							onChange={this.handleChange} value={this.state.num_alicuots || ""} className="form-control hour-input"
							style={{padding:'5px'}} />
					</div>
					<div className="col-xs-12 col-sm-2" >
						<button className="btn btn-info" type="button" onClick={this.generate}>Generar</button>
					</div>
				</div>

				<div className="col-xs-12">
					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									{this.props.state.option === 'Block'?
										<th style={{width:"3%"}}>
											<input type="checkbox" id="check_all" name="check_all" 
												onChange={this.checkAll} checked={units.length === 0 ? false : this.state.checked_all} />
										</th>
									:null}									
									<th style={{width:"8%"}}>No Unidad</th>
									<th style={{width:"20%"}}>Componente</th>
									<th style={{width:"8%"}}>No Componente</th>
									<th style={{width:"8%"}}>Fecha Donación</th>
									{this.props.state.sistema === 'CERRADO' ?
										<th style={{width:"7%"}}>Caducidad</th>
									:null}
									<th style={{width:"7%"}}>Volumen</th>
									{this.props.state.option !== 'Unit' ?
										<th style={{width:"3%"}}></th>
									:null}
									<th></th>
								</tr>
								
							</thead>
							<tbody>
								{units.map((a, i)=>{
									return <tr key={i}>
										{this.props.state.option === 'Block'?
											<td>
												<input type="checkbox" checked={this.state.component[i] !== undefined ? this.state.component[i].check : true} 
													onChange={this.onCheck.bind(this, i)}/>
											</td>
										: null}
										<td>{a.donation_number}</td>
										<td>
											{a.component !== undefined ? 
												a.component.component 
											: a.blood_component.component}
										</td>
										<td>{a.unit.component_number}</td>
										<td>
											{a.donation_date !== undefined ? 
												moment(a.donation_date).format('DD/MM/YYYY') 
											: 	moment(a.timestamp_date).format('DD/MM/YYYY') 
											}
										</td>
										{this.props.state.sistema === 'CERRADO' ?
											<td>{moment(a.unit.caducidad).format('DD/MM/YYYY')}</td>
										:null}
										<td>
											<span id={"volume_"+a.unit.id}>
												{a.unit.volume}

												{this.state.component[i] !== undefined ?
													this.state.component[i].input.length > 0 ?
														" ( "+this.state.component[i].input[0].fraction_number+" )"
													: ""
												: ""}
											</span>
										</td>
										{this.props.state.option !== 'Unit' ?
											<td style={{width:"5.5%"}}>
												<div className="col-xs-12">
													<input className="form-control volume-unit" type="number" min="1"
														id={"input_"+a.unit.id} onKeyPress={(e) => this.props.validate(e)}
														onChange={this.generateOne}
														value={this.state.component[i] !== undefined ? this.state.component[i].value : ""} 
														 />
												</div>
											</td>
										:null}
										<td>
											<div key={i} className="col-xs-12">
												{this.state.component[i] !== undefined ?
													this.state.component[i].input !== "" ?
														this.state.component[i].input.map((input, i)=>{
															return i > 0 ?
																<div key={i} className="col-sm-2" style={{width:"25%"}}>
																	<span>
																		{input.fraction_number}
																	</span>
																	<span>
																		<input  className="form-control volume-unit" type="number"
																			id={input.id} onKeyPress={(e) => this.props.validate(e)}
																			value={input.value}
																			onChange={this.onInputChange}
																			style={{display:"inline-block", width:"47%", margin:"3px 5px", padding:"3px !important"}} />
																		ml
																	</span>
																</div>
															: null
														})
													: null
												: null
												}

											</div>
										</td>
									</tr>
								})}
								{this.props.state.proc_unit_eq.value === 'YES' && this.props.state.option === 'Unit' && units.length > 0 && units[0].blood_component.component_type === 'PLAQUETAS' ?
									<tr>
										<td colSpan={5} style={{textAlign:'right'}}>Unidades Equivalentes</td>
										<td style={{paddingLeft:'0'}}>
											{this.state.equivalents.map((e, i)=>(
												i === 0 ?
													<input key={i} className="form-control volume-equivalent" type="text"
														id={e.id} onKeyPress={(e) => this.props.validate(e)}
														value={e.value}
														onChange={this.equivalentChange}
														style={{display:"inline-block", width:"75%", margin:"3px 5px", padding:"3px !important"}} />
															
													
												:null
											))}
										</td>
										<td>
											<div className="col-xs-12" style={{paddingLeft:'0'}}>
												{this.state.equivalents.map((e, i)=>(
													i > 0 ?
														<div key={i} className="col-sm-2" 
															style={{width:'25%', paddingLeft:'0'}}>
															<span>
																{'\t'}
															</span>
															<span>
																<input className="form-control volume-equivalent" type="text"
																	id={e.id} onKeyPress={(e) => this.props.validate(e)}
																	value={e.value}
																	onChange={this.equivalentChange}
																	style={{display:"inline-block", width:"47%", margin:"3px 5px 3px 24%", padding:"3px !important"}} />
															</span>
														</div>
													: null
												))}
											</div>
										</td>

									</tr>
								: null}
							</tbody>
						</Table>
					</div>
				</div>

				<Notifications />

			</div>
		)
	}
}

export default TableCreateAliquots;